import { Grid, LinearProgress, Paper, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from 'react-router-dom';



const DashboardCard = props => {

    const { icon, text, link, value } = props
    const history = useHistory();

    return (
        <Grid container item xs={3} justifyContent='space-around' onClick = {
            ()=>{
                if(text==="Equipamiento"){
                    sessionStorage.setItem('idNav', 209)//id 209 hardcodeada para equipamiento
                }
                history.push(link)
            }
        }
        style={{cursor:'pointer'}}
        >
            <Paper style={{ borderRadius: 15, minHeight: 150, alignContent: "center", width:'90%', padding:10 }}>
                <Grid container item xs={12} justifyContent="center" spacing={3}>
                    <Grid item container xs={4} justifyContent="center" alignContent="center">
                        {icon}
                    </Grid>
                    <Grid container item xs={8} alignContent="center">
                        <h3>{text}</h3>
                    </Grid>
                </Grid>
                <Grid container item xs={12} alignItems="center" justifyContent="center">
                    <Grid item xs={9}>
                        <LinearProgress variant="determinate" value={value} />
                    </Grid>
                    <Grid item xs={1} align="center">
                        <Typography variant="body2" color="textSecondary" align="right">
                            {`${value}%`}
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>

        </Grid>
    )

}

export default DashboardCard